<template>
  <Container class="bottom">
    <div class="row">
      <div class="smallprint">
        L Hawkins & Sons ltd is an appointed representative of Golden Charter
        Limited trading as Golden Charter Funeral Plans which is authorised and
        regulated by the Financial Conduct Authority (FRN:965279).
      </div>
    </div>

    <div class="row">
      <ul class="footer-links-list">
        <li>
          <RouterLink :to="{name: 'privacy'}">Privacy policy</RouterLink>
        </li>

        <li>
          <RouterLink :to="{name: 'terms'}"
            >Full terms and conditions</RouterLink
          >
        </li>
      </ul>

      <p>&copy; Copyright L Hawkins &amp; Sons. All rights reserved.</p>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/Container'
export default {
  name: 'Bottom',

  components: {
    Container
  }
}
</script>

<style lang="sass" scoped>
@import "../../stylesheets/base/variables"
@import "../../stylesheets/helpers/mixins"

.bottom
  ::v-deep .contained
    .row
      display: flex
      flex-direction: column
      border-top: 1px solid $color-underlines
      padding: $pad
      font-size: $font-size-small
      font-family: $font-main
      color: $color-text-light

      p
        font-size: $font-size-small
        font-family: $font-main
        color: $color-text-light

      @include media($media-gt-big)
        flex-direction: row
        justify-content: space-between
        align-items: center

      .smallprint
        padding: $pad
        font-size: $font-size-small
        text-align: center



  .footer-links-list
    @include list
    padding-bottom: $pad
    display: flex

    @include media($media-gt-big)
      padding: 0

    @media print
      display: none

    li
      margin-right: $pad / 2

      a
        color: $color-text-light
</style>
